export const baseTheme = {
  typography: {
    fontFamily: "'Pretendard', sans-serif",
    fontSize: "16px",
  },
  color: {
    primary: "#B10D15f0",
    primaryLight: "#FFEDED",
    primaryDarken: "#88181C",
    primaryHover: "#A50C13",
    secondary: "#aaa",
    secondaryHover: "#888",
    white: "#FFFFFF",
    black: "#1A1A1A",
    gray1: "#F9F9F9",
    gray2: "#F0F0F0",
    gray3: "#767676",
  },
};
